import * as React from "react";

import { connect } from "react-redux";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { ApplicationState } from "../../applicationState";
import { loadOhCaseDetail } from "../../crud/ohCase/actions";
import { TaskActionSubRoutes } from "../../task/taskActions/TaskActionSubRoutes";

import { ActionableTasksState } from "..";

import { ActionableTaskList } from "./ActionableTaskList";

import { Fragment } from "redux-little-router";

interface StateProps {
    task: TaskModel;
}

interface DispatchProps {
    loadOhCase: (args: { ohCaseId: string; customerId: string }) => void;
}

export const BaseUnconnected: React.FunctionComponent<StateProps & DispatchProps> = ({ task, loadOhCase }: StateProps & DispatchProps) => {

    React.useEffect(() => {
        if (task) {
            loadOhCase({
                ohCaseId: task.caseId,
                customerId: task.customer.id
            });
        }
    }, [loadOhCase, task]);

    return (
        <>
            <Fragment forRoute="/:customerId/:ohCaseId">
                <TaskActionSubRoutes />
            </Fragment>
            <Fragment forNoMatch>
                <ActionableTaskList />
            </Fragment>
        </>
    );
};

const mapStateToProps = (state: ApplicationState & ActionableTasksState): StateProps => {
    const taskId = state.router.params && state.router.params.taskId;
    return {
        task: state.actionableTasks.tasks.find(t => t.id === taskId)
    };
};

const mapDispatchToProps: DispatchProps = ({
    loadOhCase: loadOhCaseDetail
});

export const Base = connect(mapStateToProps, mapDispatchToProps)(BaseUnconnected);
